import React from 'react'
import Head from 'next/head'
import { HOST_BASE_URL } from 'infra/constants'

export const Seo: React.FCC<{
  title?: string
  description?: string
  image?: string
  url?: string
  keyword?: string
}> = ({
  title = '그룹바이 | 스타트업 채용 플랫폼',
  description = '검증된 스타트업 채용은 그룹바이에서',
  image = 'https://groupby-public-image.s3.ap-northeast-2.amazonaws.com/biz/Frame+3600.png',
  url = HOST_BASE_URL,
  keyword = '',
  children,
}) => (
  <Head>
    <title>{title}</title>
    <meta name='description' content={description} />
    <meta name='keywords' content={keyword} />

    <meta property='og:title' content={title} />
    <meta property='og:description' content={description} />
    <meta property='og:image' content={encodeURI(image)} />
    <meta property='og:url' content={url} />
    <meta name='twitter:card' content='summary_large_image' />
    <meta name='twitter:title' content={title} />
    <meta name='twitter:description' content={description} />
    <meta name='twitter:image' content={encodeURI(image)} />
    {children}
  </Head>
)
